import { getOrderFulfillmentCTA } from "./shared";
export var Reimbursement = function Reimbursement(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return reimbursementOfShippingCostBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return reimbursementOfShippingCostBuilder(strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getOrderFulfillmentC;
        return (_getOrderFulfillmentC = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC === void 0 ? void 0 : _getOrderFulfillmentC.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getOrderFulfillmentC2, _getOrderFulfillmentC3;
        return (_getOrderFulfillmentC2 = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC2 === void 0 ? void 0 : (_getOrderFulfillmentC3 = _getOrderFulfillmentC2.getLink) === null || _getOrderFulfillmentC3 === void 0 ? void 0 : _getOrderFulfillmentC3.call(_getOrderFulfillmentC2);
      }
    }
  };
};
var reimbursementOfShippingCostBuilder = function reimbursementOfShippingCostBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "n8BFCi",
        defaultMessage: [{
          "type": 0,
          "value": "Verzendkosten vergoeden wanneer je zelf verzendt"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "Rfyot8",
        defaultMessage: [{
          "type": 0,
          "value": "Je kunt bestellingen met eigen vervoerder verzenden. We vergoeden de verzendkosten bij de uitbetaling tot een goedgekeurd bedrag voor die bestellingen. Je kunt de verzendkosten en het trackingnummer toevoegen of bijwerken in ‘Stap 4. Verzendinformatie’ voor de bestellingsverwerkingspagina zodra deze beschikbaar is."
        }]
      })];
    }
  };
};